import { createSvgIcon } from "@mui/material";

export const EmailIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M14.5 4.5V11.5C14.5 12.3279 13.8279 13 13 13H3C2.17213 13 1.5 12.3279 1.5 11.5V4.5M14.5 4.5C14.5 3.67213 13.8279 3 13 3H3C2.17213 3 1.5 3.67213 1.5 4.5M14.5 4.5V4.662C14.5001 5.18273 14.23 5.66624 13.7867 5.93933L8.78667 9.016C8.3043 9.31311 7.6957 9.31311 7.21333 9.016L2.21333 5.94C1.76996 5.6669 1.49994 5.1834 1.5 4.66267V4.5" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'EmailIcon'
)
